class CommonError extends Error {
  constructor(message?: string) {
    super(`Common Error: ${message}`)
    this.name = 'CommonError'
  }
}

type HTTP_METHOD = 'DELETE' | 'GET' | 'HEAD' | 'PATCH' | 'POST' | 'PUT' | 'UNKNOWN'

export class LILeadApiError extends CommonError {
  readonly leadUuid: string
  readonly method: HTTP_METHOD

  constructor(message: string, leadUuid: string, method: HTTP_METHOD = 'UNKNOWN') {
    super(`LEAD_API_${method}_ERROR: ${message} lead=${leadUuid}`)
    this.name = 'LILeadApiError'
    this.leadUuid = leadUuid
    this.method = method
  }
}
